import { render, staticRenderFns } from "./StaffListAddNew.vue?vue&type=template&id=0cbeca0e&"
import script from "./StaffListAddNew.vue?vue&type=script&lang=js&"
export * from "./StaffListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./StaffListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports